export const CONTENT_TYPES = [
    {
        contentType: "application/json",
        handlebarsTemplate: true
    },
    {
        contentType: "application/octet-stream",
        handlebarsTemplate: false
    }
];

export const IDENTIFIERS = {
    contentType: 'content-type'
};


export const STATUS_CODES: string[] = ['200',
    '201',
    '202',
    '204',
    '300',
    '302',
    '400',
    '401',
    '403',
    '404',
    '405',
    '406',
    '409',
    '413',
    '414',
    '415',
    '422',
    '423',
    '429',
    '500',
    '502',
    '503',
    '504'];

const instanceExpiryDate = new Date();

instanceExpiryDate.setDate(instanceExpiryDate.getDate() + (10 * 365));

export const instanceExpiredDate = instanceExpiryDate;

export const USER_TYPES = ['kay', 'marie', 'paul', 'peter', 'robert', 'bart', 'marc', 'martin', 'ute', 'donald', 'daisy', 'della', 'sophie', 'sophieWithCoAdmin'];



// WEBPACK FOOTER //
// ./src/app/common/constants/defines.ts